export default "__VITE_ASSET__151Ki29z__"